module.exports = __webpack_public_path__ + "static/media/mc_screen_default.183f7ea5.svg";